// Props shared for all MUI dropdowns
export const MENU_PROPS = {
    getContentAnchorEl: null,
    anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
    elevation: 1,
    marginThreshold: 0,
};
